import { render, staticRenderFns } from "./TipsAndTricksSell.vue?vue&type=template&id=358ad10b&scoped=true&"
import script from "./TipsAndTricksSell.vue?vue&type=script&lang=ts&"
export * from "./TipsAndTricksSell.vue?vue&type=script&lang=ts&"
import style0 from "./TipsAndTricksSell.vue?vue&type=style&index=0&id=358ad10b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ad10b",
  null
  
)

export default component.exports